import React, { useCallback } from 'react';
import { Notification, toaster } from '@appkit4/react-components/notification';

type NotificationStatus = 'success' | 'error' | 'warning' | 'default';

interface ToastOptions {
  position?: 'topCenter' | 'topLeft' | 'topRight' | 'bottomCenter' | 'bottomLeft' | 'bottomRight';
  duration?: number;
  clickToClose?: boolean;
  showTimer?: boolean;
  onClose?: () => void;
}

export const useToast = () => {
  const showToast = useCallback((
    title: string,
    message: string,
    status: NotificationStatus = 'default',
    options?: ToastOptions
  ) => {
    toaster.notify(
      <Notification
        title={title}
        message={message}
        status={status}
      />,
      {
        position: options?.position || 'topCenter',
        duration: options?.duration || 50000000000,
        clickToClose: options?.clickToClose,
        showTimer: options?.showTimer,
        onClose: options?.onClose
      }
    );
  }, []);

  const showSuccess = useCallback((message: string, title: string = 'Successo', options?: ToastOptions) => {
    showToast(title, message, 'success', options);
  }, [showToast]);

  const showError = useCallback((message: string, title: string = 'Errore', options?: ToastOptions) => {
    showToast(title, message, 'error', options);
  }, [showToast]);

  const showWarning = useCallback((message: string, title: string = 'Attenzione', options?: ToastOptions) => {
    showToast(title, message, 'warning', options);
  }, [showToast]);

  const showInfo = useCallback((message: string, title: string = 'Informazione', options?: ToastOptions) => {
    showToast(title, message, 'default', options);
  }, [showToast]);

  return {
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};